<template>
	<div>
		<div class="head">
			<el-row>
				<el-col>
					<span>客户：{{ routeParams.CUSTOMER_NAME }}</span>
					<span style="margin-left:20px">供应商：{{ routeParams.SUPPLIER_NAME }}</span>
				</el-col>
			</el-row>
		</div>
		<el-row style="background:white;margin-bottom:10px">
			<el-col>
				<el-form size="medium" ref="searchForm" v-model="searchForm" :inline="true">
					<el-form-item label="产品编码：">
						<el-input size="medium" v-model="searchForm.productCode"
							onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,'')"></el-input>
					</el-form-item>
					<el-form-item label="商品名称：">
						<el-input size="medium" v-model="searchForm.productName"
							onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,'')"></el-input>
					</el-form-item>
					<el-form-item label="二级大类：">
						<el-select size="medium" v-model="searchForm.secondCatalog" filterable clearable>
							<el-option v-for="item in secondLists" :key="item.CATALOG_CODE" :label="item.CATEGORY_NAME"
								:value="item.CATALOG_CODE"></el-option>
						</el-select>
					</el-form-item>
					<el-row>
						<el-button size="medium" @click="handleSearch">筛选</el-button>
						<el-button size="medium" style="color: rgb(96,98,102)" @click="clearSearch"
							type="text">重置筛选条件</el-button>
					</el-row>
				</el-form>
			</el-col>
		</el-row>
		<div class="middle"></div>
		<div style="padding: 10px 0px;background:white;border-radius:3px">
			<el-row>
				<el-col>
					<el-table :data="tableData" stripe border>
						<el-table-column type="index" label="序号" width="80"></el-table-column>
						<el-table-column prop="PRODUCT_CODE" label="编码"></el-table-column>
						<el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
						<el-table-column prop="FIRST_CATEGORY_NAME" label="所属大类"></el-table-column>
						<el-table-column prop="SECOND_CATEGORY_NAME" label="所属二类"></el-table-column>
						<el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
						<el-table-column prop="RECOMMEND_SALE_PRICE" label="推荐销售价"></el-table-column>
						<!-- <el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="text" icon="el-icon-close" v-if="scope.row.HAS == 1"
									@click="cancelSupply(scope.row)" style="color:#F56C6C">下架</el-button>
								<el-button type="text" icon="el-icon-check" style="color:#67C23A"
									@click="startSupply(scope.row)" v-else>上架</el-button>
							</template>
						</el-table-column> -->
					</el-table>
				</el-col>
			</el-row>
			<el-row>
				<el-pagination @current-change='handlePageChange' :current-page.sync="currentPage" :total="totalNum"
					:page-size="pageSize" layout="total, prev, pager, next, jumper" style="float:right">
				</el-pagination>
			</el-row>
		</div>
	</div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      routeParams: this.$route.params.row,
      projectName: this.$route.query.project_name,
      supplierName: this.$route.query.supplier_name,
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        productCode: '',
        productName: '',
        secondCatalog: '',
      },
      tc_name: sessionStorage.getItem('tc_name'),
      secondLists: [],
      GYS_ID: Number(sessionStorage.getItem('tcId')),
    };
  },
  created() {
    console.log('this.$route.params.row', this.$route.params.row);
    // if ('CONDITION' in this.NEWPROJECTPRODUCT_DATA_CONDITION && 'DATA' in this.NEWPROJECTPRODUCT_DATA_CONDITION && 'TOTAL_COUNT' in this.NEWPROJECTPRODUCT_DATA_CONDITION) {
    // 	this.tableData = this.NEWPROJECTPRODUCT_DATA_CONDITION.DATA
    // 	this.searchForm = this.NEWPROJECTPRODUCT_DATA_CONDITION.CONDITION
    // 	this.totalNum = this.NEWPROJECTPRODUCT_DATA_CONDITION.TOTAL_COUNT
    // }
    // 这里用来在系统设置中设置页面展示条目，文件在systemSetting的unitManage中，由前端控制条目，存储于localStorage中，key为USER_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.defaultQuery();
    this.queryUpdateProductCatalog();
  },
  computed: {
    // NEWPROJECTPRODUCT_DATA_CONDITION() {
    // 	return this.$store.state.NEWPROJECTPRODUCT_DATA_CONDITION
    // }
  },
  methods: {
    queryUpdateProductCatalog() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 8,
        SCHEME_ID: this.routeParams.SCHEME_ID,
        GYS_ID: this.GYS_ID,
      };
      http
        .post(params)
        .then((result) => {
          result[0].DETAIL.forEach((element) => {
            element.children.forEach((item) => { this.secondLists.push(item); });
          });
          console.log('this.secondLists', this.secondLists);
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    defaultQuery() {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 30,
        SUPPLIER_ID: this.routeParams.SUPPLIER_ID,
        GYS_ID: this.GYS_ID,
        CUSTOMER_ID: this.routeParams.CUSTOMER_ID,
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      if (this.searchForm.productCode) {
        const reg = /^\d+$/; // 非负整数
        if (!reg.test(this.searchForm.productCode)) {
          this.$message.show({ text: '请输入正确编码格式', type: 'error' });
          return;
        }
        params.PRODUCT_CODE = this.searchForm.productCode;
      }
      if (this.searchForm.productName) {
        params.PRODUCT_NAME = this.searchForm.productName;
      }
      if (this.searchForm.secondCatalog) {
        params.CATEGORY_CODE = this.searchForm.secondCatalog;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].PRODUCT_LIST;
          this.totalNum = result[0].TOTAL_COUNT;
          // if (this.searchForm) {
          // this.$store.dispatch('SET_NEWPROJECTPRODUCT_DATA_CONDITION', {
          // 	CONDITION: this.searchForm,
          // 	DATA: this.tableData,
          // 	TOTAL_COUNT: this.totalNum
          // })
          // }
        } else {
          this.tableData = [];
          this.totalNum = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // cancelSupply(row) {
    // 	this.$confirm('您确定要对该项目点取消供应该类商品?', '提示', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		type: 'warning'
    // 	}).then(() => {
    // 		let params = {
    // 			SERVICE_ID: '10023',
    // 			OTYPE: 14,
    // 			SUPPLIER_ID: Number(this.$route.query.supplier_id),
    // 			PROJECT_ID: Number(this.$route.query.project_id),
    // 			PRODUCT_CODE: row.PRODUCT_CODE,
    // 			TC_ID: sessionStorage.getItem('tc_id')
    // 		}
    // 		http.post(params).then(result => {
    // 			this.$message.show({ text: '取消供应成功', type: 'success' })
    // 			this.defaultQuery(this.currentPage)
    // 		}).catch(error => {
    // 			this.$message.show({ text: error, type: 'error' })
    // 		})
    // 	}).catch(() => {
    // 		this.$message.show({
    // 			type: 'info',
    // 			text: '取消操作'
    // 		})
    // 	})
    // },
    // startSupply(row) {
    // 	this.$confirm('您确定要对该项目点开始供应该类商品?', '提示', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		type: 'warning'
    // 	}).then(() => {
    // 		let params = {
    // 			SERVICE_ID: '10023',
    // 			OTYPE: 15,
    // 			SUPPLIER_ID: Number(this.$route.query.supplier_id),
    // 			PROJECT_ID: Number(this.$route.query.project_id),
    // 			PRODUCT_CODE: row.PRODUCT_CODE,
    // 			DEFAULT_POINT: sessionStorage.getItem('pointType'),
    // 			TC_ID: sessionStorage.getItem('tc_id')
    // 		}
    // 		http.post(params).then(result => {
    // 			if ('delProdUrl' in result[0]) {
    // 				if (result[0].delProdUrl != '') {
    // 					this.$message.show({ text: '由于排它功能下架的产品已导出', type: 'success' })
    // 					window.location.href = result[0].delProdUrl
    // 					document.body.style.cursor = 'default'
    // 				}
    // 			}
    // 			this.$message.show({ text: '开始供应成功', type: 'success' })
    // 			this.defaultQuery()
    // 		}).catch(error => {
    // 			this.$message.show({ text: error, type: 'error' })
    // 		})
    // 	}).catch(() => {
    // 		this.$message.show({
    // 			type: 'info',
    // 			text: '取消操作'
    // 		})
    // 	})
    // },
    handlePageChange(e) {
      this.defaultQuery();
      this.currentPage = e;
    },
    handleSearch() {
      this.currentPage = 1;
      this.defaultQuery();
    },
    clearSearch() {
      this.searchForm = {};
    },
  },
};
</script>
<style scoped>
.pagination_box {
	float: right;
	margin-top: 10px;
}

.middle {
	width: 100%;
	height: 10px;
	line-height: 60px;
	background-color: #f5f7f9;
	margin: 0 -20px 0 -20px;
}

.search {
	width: 100%;
}

.head {
	background: white;
	border-radius: 3px;
	padding: 20px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/newProjectProduct.vue